import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import Yup from 'yup';
import SubmitButton from 'base/components/forms/SubmitButton';
import FormikInputField from 'base/components/forms/formik/FormikInputField';
import FormikSelectField from 'base/components/forms/formik/FormikSelectField';
import {
  getUsersSelectOptions,
} from 'auth/store/users/selectors';


const SpaceForm = ({
  space, onSubmit, userSelectOptions,
}) => (
  <Formik
    initialValues={{
      name: space.name || '',
      owner: space.owner || '',
    }}
    validationSchema={
            Yup.object().shape({
              name: Yup.string()
                .required('Name is required.'),
              owner: Yup.number()
                .required('Space owner is required.'),
            })
          }
    render={({errors, isSubmitting}) => ( // eslint-disable-line
      <Form>
        <Field
          type="text"
          name="name"
          label="Name"
          placeholder="Name"
          component={FormikInputField}
          autoFocus
        />
        <Field
          type="select"
          name="owner"
          component={FormikSelectField}
          label="Space owner"
          options={userSelectOptions}
        />
        <SubmitButton type="submit" disabled={isSubmitting}>
      Save space
        </SubmitButton>
      </Form>
    )}
    onSubmit={(values) => {
      const updatedSpace = {
        ...space,
        name: values.name,
        owner: values.owner,
      };
      onSubmit(updatedSpace);
    }}
  />
);
SpaceForm.propTypes = {
  space: PropTypes.objectOf(PropTypes.any),
  onSubmit: PropTypes.func.isRequired,
  userSelectOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
};
SpaceForm.defaultProps = {
  space: {},
};

const mapStateToProps = (state) => ({
  userSelectOptions: getUsersSelectOptions(state),
});

const mapDispatchToProps = {
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SpaceForm);
